// removed by extract-text-webpack-plugin
module.exports = {"heading":"heading","textLeft":"textLeft","textCenter":"textCenter","perf-table-container":"perf-table-container","table":"table","perf-footnote":"perf-footnote","percentage":"percentage","date":"date","name":"name","ticker":"ticker","mobile-hide":"mobile-hide","sticky":"sticky","mobile-show":"mobile-show","borderleft":"borderleft","borderRight":"borderRight","borderbottom":"borderbottom","subjectToChange":"subjectToChange","tickerLink":"tickerLink"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/wt-react/dist/components/StandardPerformance/StandardPerformanceTable.css
// module id = 1149
// module chunks = 0